
import React, { useEffect, useState } from "react"

const Section = ({ id, className, maxWidthClass = "max-w-theme-max-w", background, children }) => {

  const ref = React.useRef()
  const [height, setHeight] = useState();

  useEffect(() => {
    function handleResize() {
      setHeight(ref.current.offsetHeight);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    }
  })

  return (
    <>
      <section id={id} className={`px-4 2xl:px-0 ${className}`}>
        <div style={{ height: `${height}px` }} className={`my-0 mx-auto absolute w-full left-0`}>
          {background}
        </div>
        <div ref={ref} className={`${maxWidthClass} my-0 mx-auto `}>
          {children}
        </div>
      </section>
    </>
  )

}


export default Section